import axiosInstance from '../utils/config'
import WHATSAPP_CONSTANTS, { ADMIN_NOTES_CONSTANTS } from '../constants/constantsConstants'

const PREFIX = 'api/v1/constants/whatsapp_message'
const ADMIN_NOTES_PREFIX = 'api/v1/constants/ADMIN_NOTES'

// Get WhatsApp message
export const getWhatsAppMessage = () => async (dispatch) => {
  try {
    dispatch({ type: WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_REQUEST })
    
    const { data } = await axiosInstance.get(PREFIX)
    
    dispatch({
      type: WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_SUCCESS,
      payload: data?.value,
    })
  } catch (error) {
    dispatch({
      type: WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// Update WhatsApp message
export const updateWhatsAppMessage = (message) => async (dispatch) => {
  try {
    dispatch({ type: WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_REQUEST })
    
    const { data } = await axiosInstance.put(PREFIX, {
      value: message
    })
    
    dispatch({
      type: WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_SUCCESS,
      payload: data?.value,
    })
  } catch (error) {
    dispatch({
      type: WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// Get Admin Notes
export const getAdminNotes = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_REQUEST })
    
    const { data } = await axiosInstance.get(ADMIN_NOTES_PREFIX)
    
    dispatch({
      type: ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_SUCCESS,
      payload: data?.value,
    })
  } catch (error) {
    dispatch({
      type: ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// Update Admin Notes
export const updateAdminNotes = (notes) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_REQUEST })
    
    const { data } = await axiosInstance.put(ADMIN_NOTES_PREFIX, {
      value: notes
    })
    
    dispatch({
      type: ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_SUCCESS,
      payload: data?.value,
    })
  } catch (error) {
    dispatch({
      type: ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}